<template>
  <div class="secondary_bg_color">
    <div class="w_90 m-auto pt-3" style="height: 500px">
      <h5 class="call_to_action_text_color">Donation</h5>
    </div>
  </div>
</template>